SubjectRankings = new (function () {
  let wrapper;

  this.bindEvents = () => {
    if (!wrapper || !wrapper.length) return;

    const stickyTable = new Shared.StickyTable();

    $(document).ajaxComplete(function () {
      let tableWrapper = $(".table-body-wrapper", wrapper);
      if (tableWrapper) {
        tableWrapper.floatingScroll();
        stickyTable.bind();
      }
    });
  };

  this.initForm = () => {
    wrapper = $(".manage-subject-rankings");
  };
})();
